module.exports = __webpack_public_path__ + "static/img/pushpin-red.0994046c.png";